import * as React from "react";
import ReactPlayer from "react-player";
import fileVideo from "assets/images/video.mp4";
import buttonVote from "assets/images/button-vote.svg";
import buttonVoteEn from "assets/images/vote-sm-en.svg";

function Video(props) {
  const { lang, width, video } = props;
  // const [video, setVideo] = React.useState({
  //   src: fileVideo,
  //   poster: "/1.png",
  // });
  const LinkVoting = () => (
    window.open("https://citypoptokyo.deform.cc/voting/?page_number=0", "_blank")
  );
  return (
    <div
      className="m-auto"
      style={{
        width: width,
      }}
    >
      <ReactPlayer url={video} controls width="100%" height="auto" />

      <img
        className="mx-auto my-8 cursor-pointer"
        loading="lazy"
        src={lang === "en" ? buttonVoteEn : buttonVote}
        alt="buttonVote"
        onClick={LinkVoting}
      />
    </div>
  );
}
export default Video;
